import API from "./axios";

export const getParticipants = (event_id) => {
  return API.get(`/rooms/events/participants/`, {
    params: {
      event_id,
    },
  });
};
